var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "L6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    stroke: "#333333",
    strokeWidth: 4,
    x: 25,
    y: 25,
    width: 50,
    height: 50
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "0.5s",
    from: "0 50 50",
    to: "180 50 50",
    type: "rotate",
    id: "strokeBox",
    attributeType: "XML",
    begin: "rectBox.end"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 27,
    fill: "#4CAF50",
    width: 46,
    height: 50
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    dur: "2s",
    attributeType: "XML",
    from: 50,
    to: 0,
    id: "rectBox",
    fill: "freeze",
    begin: "0s;strokeBox.end"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading6);
export default __webpack_public_path__ + "static/media/loading-6.5a23b28919f2194e8ae0ac963f588676.svg";
export { ForwardRef as ReactComponent };